import { parseDate } from './parseDate.js'
import { formatDate } from './format.js'
import { add } from './addSubtract.js'
import { endOf } from './endOf.js'
import { diff, isSameOrAfter, isSameOrBefore } from './compare.js'
import { startOf } from './startOf.js'
import { formatRelative } from './formatRelative.js'

export const aawzDate = (dateInput, inputFormat) => {
  let date =
    dateInput instanceof Date
      ? new Date(dateInput)
      : typeof dateInput === 'string' && inputFormat
      ? parseDate(dateInput, inputFormat)
      : typeof dateInput === 'number' && String(dateInput).length === 10
      ? new Date(dateInput * 1000)
      : new Date(dateInput || Date.now())

  const isInvalid = isNaN(date.getTime())

  const self = {
    format: (mask) => formatDate(date, mask),
    formatRelative: (baseDate) => formatRelative(date, baseDate),

    add: (amount, unit) => {
      date = add(date, amount, unit)
      return self
    },

    subtract: (amount, unit) => {
      date = add(date, -amount, unit)
      return self
    },

    endOf: (unit) => {
      date = endOf(date, unit)
      return self
    },

    startOf: (unit) => {
      date = startOf(date, unit)
      return self
    },

    isSameOrAfter: (compareDate) => isSameOrAfter(date, compareDate),

    isSameOrBefore: (compareDate) => isSameOrBefore(date, compareDate),

    diff: (dateDiff, unity) =>
      diff(
        date,
        dateDiff instanceof Date ? dateDiff : parseDate(dateDiff),
        unity
      ),

    year: () => date.getFullYear(),

    month: () => date.getMonth(),

    toDate: () => new Date(date.getTime()),

    isValid: () => !isInvalid,
    toString: () => date.toString(),
    valueOf: () => date.getTime(),
    unix: () => Math.floor(date.getTime() / 1000),
  }

  let proxy

  const fallbackValues = {
    format: () => 'Invalid date',
    formatRelative: () => 'Invalid date',
    add: () => proxy,
    subtract: () => proxy,
    endOf: () => proxy,
    startOf: () => proxy,
    diff: () => Number.NaN,
    isSameOrAfter: () => false,
    isSameOrBefore: () => false,
    year: () => Number.NaN,
    month: () => Number.NaN,
    toDate: () => new Date(''),
    toString: () => 'Invalid Date',
    valueOf: () => Number.NaN,
    isValid: () => false,
    unix: () => Number.NaN,
  }

  proxy = new Proxy(self, {
    get(target, prop) {
      if (isInvalid) {
        return fallbackValues[prop] || (() => undefined)
      }
      return typeof target[prop] === 'function'
        ? target[prop].bind(target)
        : target[prop]
    },
  })

  return proxy
}
